import design from "./design.svg";
import bussiness from "./bussiness.svg";
import music from "./music.svg";
import others from "./others.svg";
import photography from "./photography.svg";
import software from "./software.svg";
const courseCatgory = {
  design,
  bussiness,
  music,
  others,
  photography,
  software,
};
export default courseCatgory;
